// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.contactum-range-preview[data-v-5ebdb4f3] {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.contactum-range-slider-preview[data-v-5ebdb4f3] {\n  flex: 1;\n}\n.contactum-range-preview-val[data-v-5ebdb4f3] {\n  min-width: 40px;\n  text-align: right;\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
